import { render } from "./BaseBtn.vue?vue&type=template&id=22d2c9fe&scoped=true"
import script from "./BaseBtn.vue?vue&type=script&lang=js"
export * from "./BaseBtn.vue?vue&type=script&lang=js"

import "./BaseBtn.vue?vue&type=style&index=0&id=22d2c9fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d2c9fe"]])

export default __exports__